import { gql } from "@apollo/client"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { CreateDocumentInput } from "@oysterhr/schema"

const MUTATION = gql`
  mutation StaffCompanyPaymentStatusUploadDocument($input: CreateDocumentInput!) {
    createDocument(input: $input) {
      errors
    }
  }
`

export const useUploadDocument = (
  options?: InjectedOptions<
    { createDocument: { errors: string[] } },
    { input: CreateDocumentInput }
  >,
) => useMutation(MUTATION, options)
